import { Api } from "./Api";

export class KiService extends Api {
    getAllScreens = async () => {
        return await this.get("/search?q=collectionId:12 AND documentType:display&status=publish");
    }

    getAllZones = async () => {
        let data = [];
        try {
            const _data = await this.get("/search?q=collectionId:12 AND documentType:zone&status=publish");
            data = _data.models;

        }catch (err) {
            console.error(err);
        }
        finally{
            return data;
        }
        
    }

    getZone = async (zoneId: string) => {
        let data = [];
        try {
            const _data = await this.get(`/search?q=collectionId:12 AND documentType:zone AND zone:${zoneId}&status=publish`);
            data = _data.models;
        }
        catch (err) {
            console.error(err);
        }
        finally{
            return data;
        }
    }


    getById = async (id: number) => {
        let data = [];
        try {
            const _data = await this.get(`/search?q=id:${id}`); //&status=publish
            data = _data.models;
        }
        catch (err) {
            console.error(err);
        }
        finally{
            return data;
        }
    }

    getByIds = async (id: number[]) => {
        let data = {};

        // creates a string formatted like "0 OR id:1 OR id:2 OR id:3"
        const idQuery = id.reduce((accStr, el, idx )=>{ return accStr + (!idx ? el.toString() : " OR id:"+el)}, "");
        try {
            const _data = await this.get(`/search?q=id:${idQuery}&status=publish`);
            data = _data.models;
        }
        catch (err) {
            console.error(err);
        }
        finally{
            return data;
        }
    }

    getByUuid = async (uuid: string) =>{
        let data = [];

        try {
            const _data = await this.get(`/documents/${uuid}?include_media=true`);
            data = _data;
        }
        catch (err){
            console.error(err);
        }
        finally{
            return data;
        }
    }

    getByReferencedFromId = async (id: string) =>{
        let data = [];

        try {
            const _data = await this.get(`/documents/?include_media=true&referenced_from_document_id=${id}`);
            data = _data;
        }
        catch (err){
            console.error(err);
        }
        finally{
            return data;
        }
    }

    getMedia = async(id: string) =>{
        let data = [];

        try {
            const _data = await this.get(`/media/${id}`);
            data = _data;
        }
        catch (err){
            console.error(err);
        }
        finally{
            return data;
        }
    }

    getProcessedFields = async(ids: string[])=>{
        let data = [];
        let query_string = ""
        ids.forEach((_id, idx)=>{
            query_string += `${idx===0?"":"&"}d=${_id}`
        })
        const reqBody = {
            document_ids: ids
        }
        try {
            data = await this.post(`/documents/fields/`, reqBody );
            //data = _data;
        }
        catch (err){
            console.error(err);
        }
        finally{
            return data;
        }
    }



}